import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tv-merchants-cycle"
export default class extends Controller {
  static targets = ["page"];
  static values = { interval: { type: Number, default: 5000 } };

  connect() {
    this.currentIndex = 0;
    this._showCurrentPage();

    this.timer = setInterval(() => this._showNextPage(), this.intervalValue);

    // A Turbo morph refresh re-renders the server's initial page visibility
    // (only the first tbody shown) without disconnecting this controller, so
    // re-apply the page we were on rather than snapping back to the first.
    this.onMorph = () => this._showCurrentPage();
    document.addEventListener("turbo:morph", this.onMorph);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
    document.removeEventListener("turbo:morph", this.onMorph);
  }

  _showNextPage() {
    this.currentIndex += 1;
    this._showCurrentPage();
  }

  _showCurrentPage() {
    if (this.pageTargets.length === 0) return;

    this.currentIndex %= this.pageTargets.length;
    this.pageTargets.forEach((page, index) => {
      page.hidden = index !== this.currentIndex;
    });
  }
}
